import * as angular from 'angular';
import Pricing from "./pricing/pricing";
import OrderNumber from "./orderNumber/order.number.index";
import PricingDetails from "./pricing/details/pricing.details.js";
import PricingService from "./pricing/pricing.service.js";
import PricingNumbersService from "./pricing/pricing.numbers.service.js";
import EmailSenderPricingService from "./pricing/emails.sender.pricing.service.js";
import PricingFilter from "./pricing/pricing.filter";
import MenuBillingsPricing from "./menu/menu.billings.pricing";
import LiveChatService from "../utils/live-chat/live.chat.service";

export default angular.module('CrazyWeb.Billings', [OrderNumber])
    .component("pricing", Pricing)
    .component("pricingDetails", PricingDetails)
    .component("menuBillingsPricing", MenuBillingsPricing)
    .service("Pricing", PricingService)
    .service("PricingNumbersService", PricingNumbersService)
    .service("EmailSenderPricingService", EmailSenderPricingService)
    .service("LiveChatService", LiveChatService)
    .filter("pricingFilter", PricingFilter).name
